import { render, staticRenderFns } from "./ModalTaxReceipts.vue?vue&type=template&id=4437b5c2&lang=pug&"
import script from "./ModalTaxReceipts.vue?vue&type=script&lang=js&"
export * from "./ModalTaxReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports